<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <el-date-picker
      v-if="status === 'edit'"
      v-model="form.fieldValue"
      style="width: 100%"
      type="date"
      :clearable="!form.mandatory"
      placeholder="选择日期">
    </el-date-picker>
    <span v-else>
      <span v-if="form.fieldValue">{{ form.fieldValue | dateformat('YYYY-MM-DD') }}</span>
      <span v-else>&nbsp;</span>
    </span>
  </el-form-item>
</template>

<script>
export default {
  name: 'FormDate',
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'blur'
        }
      ]
    }
  }
}
</script>
